import { Button } from "antd";
import styled from "styled-components";
import { COLORS } from "../../../layout/theme";

export const PageWrapper = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
	padding: 10px 0 30px 0;
`;

export const ContentCard = styled.div`
	width: 100%;
	max-width: 1120px;
	background: ${COLORS.White};
	border-radius: 20px;
	padding: 40px 40px;
	box-shadow: 0 6px 24px rgba(15, 23, 42, 0.06);

	@media only screen and (max-width: 768px) {
		padding: 24px 16px;
		border-radius: 14px;
	}
`;

export const PageTitle = styled.h1`
	margin: 0 0 30px 0;
	text-align: center;
	font-size: 34px;
	font-weight: 700;
	line-height: 1.1;
	color: #0f172a;

	@media only screen and (max-width: 768px) {
		font-size: 30px;
		margin-bottom: 24px;
	}
`;

export const Inner = styled.div`
	display: flex;
	flex-direction: column;
	gap: 28px;
`;

export const AuditCard = styled.div`
	width: 100%;
	background: #f8fafc;
	border: 1px solid #e2e8f0;
	border-radius: 16px;
	padding: 34px 36px;

	@media only screen and (max-width: 768px) {
		padding: 22px 16px;
	}
`;

export const SectionTitle = styled.h2`
	margin: 0 0 28px 0;
	font-size: 22px;
	font-weight: 700;
	color: #1e293b;

	@media only screen and (max-width: 768px) {
		font-size: 22px;
	}
`;

export const FilterGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 28px;
	margin-bottom: 28px;

	@media only screen and (max-width: 768px) {
		grid-template-columns: 1fr;
		gap: 18px;
	}
`;

export const FieldGroup = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: end;
	gap: 10px;
	width: 100%;
`;

export const FieldLabel = styled.label`
	font-size: 16px;
	font-weight: 700;
	color: #334155;
`;

export const FilterContainer = styled.div`
	width: 100%;

	.ant-picker {
		width: 100%;
		height: 56px;
		border-radius: 14px;
		border: 1px solid #cbd5e1;
		padding: 0 16px;
		font-size: 16px;
		box-shadow: none;
	}

	.ant-picker:hover,
	.ant-picker-focused {
		border-color: #7c3aed;
		box-shadow: 0 0 0 2px rgba(124, 58, 237, 0.08);
	}

	.ant-picker-input > input {
		font-size: 16px;
		color: #334155;
	}
`;

export const AntdButton = styled(Button)`
	width: 100%;
	height: 56px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	background: linear-gradient(
		90deg,
		${COLORS.Secondary},
		${COLORS.Secondary} 100%
	); //linear-gradient(90deg, #4f46e5 0%, #4f46e5 100%);
	color: ${COLORS.White};
	border: none;
	border-radius: 14px;
	font-size: 18px;
	font-weight: 700;
	padding: 0 24px;
	box-shadow: 0 8px 18px rgba(79, 70, 229, 0.22);

	&:hover,
	&:focus,
	&:active {
		background: linear-gradient(90deg, #4338ca 0%, #4338ca 100%) !important;
		color: ${COLORS.White} !important;
		border: none !important;
	}

	& span,
	& svg {
		color: ${COLORS.White};
	}

	&.ant-btn-loading {
		opacity: 0.9;
	}
`;

export const ClientBox = styled.div`
	width: 100%;
	height: 58px;
	display: flex;
	align-items: center;
	padding: 0 16px;
	border-radius: 14px;
	border: 1px solid #cbd5e1;
	background: ${COLORS.White};
	font-size: 16px;
	color: #64748b;
`;
